"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalPropTypes = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop2 = _interopRequireDefault(require("lodash/noop"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icons = require("../../atoms/Icons");

var _atoms = require("../../atoms");

var _Portal = _interopRequireDefault(require("../Portal"));

require("./Modal.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Modal(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$containerClass = props.containerClassName,
      containerClassName = _props$containerClass === void 0 ? '' : _props$containerClass,
      _props$contentClassNa = props.contentClassName,
      contentClassName = _props$contentClassNa === void 0 ? '' : _props$contentClassNa,
      open = props.open,
      id = props.id,
      children = props.children,
      header = props.header,
      footer = props.footer,
      _props$onClose = props.onClose,
      onClose = _props$onClose === void 0 ? _noop2.default : _props$onClose,
      _props$closeButton = props.closeButton,
      closeButton = _props$closeButton === void 0 ? true : _props$closeButton,
      data = props.data,
      _props$bigModal = props.bigModal,
      bigModal = _props$bigModal === void 0 ? false : _props$bigModal;
  var handleKeyDown = (0, _react.useCallback)(function (e) {
    if (e.key === 'Escape') {
      onClose(data);
    }
  }, [onClose]);
  (0, _react.useEffect)(function () {
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open]);
  var handleClose = (0, _react.useCallback)(function () {
    onClose(data);
  }, [onClose]);
  return open ? /*#__PURE__*/_react.default.createElement(_Portal.default, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "Modal min-w-screen h-screen animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-20 outline-none focus:outline-none bg-no-repeat bg-center bg-cover"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "absolute bg-gray-900 opacity-50 inset-0 z-0"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('w-full max-w-lg p-5 relative mx-auto -mt-80 rounded-xl shadow-lg  bg-white', bigModal ? 'BigModal__container' : 'Modal__container', className),
    id: id,
    role: "dialog"
  }, closeButton && /*#__PURE__*/_react.default.createElement(_atoms.Button, {
    onClick: handleClose,
    transparent: true,
    className: "close fixed"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_Icons.Times, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-dialog modal-md modal-dialog-centered ".concat(containerClassName),
    role: "document"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(bigModal ? 'BigModal__content' : 'modal-content', contentClassName)
  }, header, children, footer))))) : null;
}

var modalPropTypes = {
  open: _propTypes.default.bool,
  id: _propTypes.default.string,
  children: _propTypes.default.node,
  header: _propTypes.default.node,
  footer: _propTypes.default.node,
  onClose: _propTypes.default.func,
  closeButton: _propTypes.default.bool,
  className: _propTypes.default.string,
  containerClassName: _propTypes.default.string,
  contentClassName: _propTypes.default.string,
  data: _propTypes.default.any,
  bigModal: _propTypes.default.bool
};
exports.modalPropTypes = modalPropTypes;
Modal.propTypes = modalPropTypes;
var _default = Modal;
exports.default = _default;